import { Button, Checkbox, Col, Dropdown, Form, Input, Menu, message, Modal, Row, Select, Spin, Tabs, Tooltip } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux';
import { EmptyData } from './EmptyData';
import { Loading } from './Loading';
import styles from "../../Rtd/style/rtd.module.css";
import { DeleteOutlined, ExclamationCircleOutlined, FileImageOutlined, FileTextOutlined, InfoCircleOutlined, MoreOutlined, PlusCircleFilled } from '@ant-design/icons';
import { FaRegFilePdf, FaFileCsv, FaFileExcel, FaFileArchive } from "react-icons/fa";
import RtdLegend from './RtdLegend';
import { IoCloudUploadOutline } from "react-icons/io5";
import UploadPdfDoc from '../../PropertyComp/components/UploadPdfDoc';
import { transactionLaneDataHandle } from '../../Rtd/state/actions';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import moment from "moment";
import PropertyDocsDragger from '../../PropertyComp/components/PropertyDocsDragger';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import PropertyDocsTable from '../../PropertyComp/components/PropertyDocsTable';
import { PropertyHandlers } from '../../PropertyComp/state/actions';
import { formatAddress, formatBaseName, formatCLientAddress, formatDate, formatPhoneNumber } from '../utils/extraFunctions';
import { commonOfferTableFunc, commonStatusFunc, getBackgroundColor, getOfferTableColor } from '../commondata/commonData';
import NumberFormat from 'react-number-format';
import PhoneInput from 'react-phone-input-2';
import ChecklistAddItem from './ChecklistAddItem';
import styles1 from "../style/ChecklistCommission.module.css"
import { MdOutlineFileDownload } from "react-icons/md";
import { useMediaQuery } from 'react-responsive';
import { formatPrice } from '../../DocumentSection/utils/helper';
import { useHistory } from 'react-router-dom';
// import JSZip from 'jszip';
// import { saveAs } from 'file-saver';

const { TabPane } = Tabs;
const { Option } = Select;

const ChecklistTable = ({ section, checklistTable, setChecklistTable, client, delegateSide, currentAgentDetails, origin, item }) => {
  const delegate = (section === "DELEGATE");
  const { checklistData, checklistDataLoading, checklistMiniLoading, callCheckList, transactionReportData, sourceOfBusinessData, sourceOfBusinessLoading, checkListDataOnOffer, getTransactionLaneData, additionalData } = useSelector((state) => state.rtdTransactionLane, shallowEqual);
  let { updatedPropertyDoc, uploadedPdfDocSuccess, propertyDocs, propertDocsLoading } = useSelector((state) => state.PropertyReducer, shallowEqual);

  const dispatch = useDispatch();
  const location = useLocation();
  const scrollToIdRef = useRef(null);
  const inputChangedRef = useRef(false);
  const isSmallScreen = useMediaQuery({ maxWidth: 480 });
  const history = useHistory()

  const rowStyle = {
    paddingBottom: '8px'
  };

  const labelStyle = {
    fontWeight: 'bold',
    fontSize: '14px',
    color: '#555',
  };

  const valueStyle = {
    fontSize: '14px',
    color: '#000',
  };

  const cleanCurrency = (val) => {
    if (typeof val === "string") {
      return val.replace(/[^0-9.]/g, '');
    }
    return val;
  };

  const commonStatus = client === "SELLER" ? commonOfferTableFunc({ key: transactionReportData?.currentStatus }) : commonStatusFunc({ key: transactionReportData?.currentStatus });
  let statusLabel = client === "SELLER" ? getOfferTableColor({ key: commonStatus?.key, type: "TEXT" }) : getBackgroundColor({ key: commonStatus?.key, type: "TEXT" });

  const [form] = Form.useForm();
  const [referralForm] = Form.useForm();
  const [commissionForm] = Form.useForm();
  const [renameForm] = Form.useForm();

  const grossCommissionValue = Form.useWatch("grossCommission", commissionForm);
  const totalCommissionValue = Form.useWatch("totalCommission", commissionForm);

  // const isTotalValid = Math.floor(+String(grossCommissionValue || 0).replace(/[^\d.]/g, '')) ===
  //   Math.floor(+String(totalCommissionValue || 0).replace(/[^\d.]/g, ''));

  const gross = +String(grossCommissionValue || 0).replace(/[^\d.]/g, '');
  const total = +String(totalCommissionValue || 0).replace(/[^\d.]/g, '');

  const isTotalValid = gross > 0 && Math.floor(gross) === Math.floor(total);


  const [showlegend, setShowLegend] = useState(false);
  const [showPropertyDocUpload, setShowPropertyDocUpload] = useState(false);
  const [allData, setAllData] = useState({
    uploadPdfDoc: false,
    file: "",
    doraDocItem: {},
    ...(delegateSide
      ? {
        delegateSide: client === "SELLER" ? "SELLER" : "BUYER",
        delegateOwnerId: currentAgentDetails?._id,
      }
      : {}),
  });
  const [checkboxSelected, setCheckboxSelected] = useState([])

  const [agent, setAgent] = useState({
    referralSave: false,
    commissionSave: false,
    isModalVisible: false,
    downloadModal: false,
    renameModal: false,
    renamableItem: null,
  });

  const [addItems, setAddItems] = useState({
    addItemModalOpen: false,
    addedItems: [],
  })

  const fileOptions = [{ label: "Transaction Summary Report", value: 'transactionSummary' }, { label: "Checklist Report", value: 'tableChecklist' }, { label: "Commission Report", value: 'commisionDistribution' }];
  const zipFileOptions = [{ label: "Documents", value: 'documents' }];
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedZipFolder, setSelectedZipFolder] = useState([]);
  const [shortfallAmount, setShortfallAmount] = useState(null);

  const allSelected = fileOptions.length === selectedFiles.length;

  const handleSelectAll = (e) => {
    setSelectedFiles(e.target.checked ? fileOptions?.map((ele)=>ele.value) : []);
    setSelectedZipFolder([]);
  };

  const handleGroupChange = (checkedValues) => {
    setSelectedFiles(checkedValues);
    setSelectedZipFolder([]);
  };

  const handleZipChange = (checkedValues) => {
    setSelectedZipFolder(checkedValues);
    setSelectedFiles([]);
  };

  const sectionRefs = {
    TransactionSummary: useRef(null),
    ChecklistReport: useRef(null),
    CommissionDistribution: useRef(null),
    ComplianceFiles: useRef(null),
  };

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const isWeb = true;

  const handleCancel = () => {
    setChecklistTable({ ...checklistTable, openTable: false })
  }

  const propertyInfo = () => {
    return <div style={{ padding: '0 10px' }}>
      <Row style={rowStyle}>
        <Col span={6} style={labelStyle}>
          Transaction:
        </Col>
        <Col span={18} style={valueStyle}>
          {/* {transactionReportData?.currentStatus || 'N/A'} */}
          {statusLabel?.value}
        </Col>
      </Row>
      <Row style={rowStyle}>
        <Col span={6} style={labelStyle}>
          Address:
        </Col>
        <Col span={18} style={valueStyle}>
          {transactionReportData?.address || 'N/A'}
        </Col>
      </Row>
      <Row style={rowStyle}>
        <Col span={6} style={labelStyle}>
          Property Type:
        </Col>
        <Col span={18} style={valueStyle}>
          {/* {item?.Owners || 'N/A'} */}
          {getTransactionLaneData?.length > 0 ? getTransactionLaneData?.[0]?.contractType === "CBS_LAND" ? "Land" : getTransactionLaneData?.[0]?.contractType === "CBS_CL" ? "Commercial" : "Residential" : ""}
        </Col>
      </Row>
      <Row style={rowStyle}>
        <Col span={6} style={labelStyle}>
          Sales Price:
        </Col>
        <Col span={18} style={valueStyle}>
          {transactionReportData?.purchasePrice ? `$${transactionReportData?.purchasePrice}` : 'N/A'}
        </Col>

      </Row>
      <Row style={rowStyle}>
        <Col span={6} style={labelStyle}>
          Legal Description:
        </Col>
        <Col span={18} style={valueStyle}>
          {transactionReportData?.legalDescription || 'N/A'}
        </Col>
      </Row>
    </div>
  }

  const getStatusIcon = (ele, isUpload) => {
    if (ele?.signaturesVerified) {
      return <div className={styles.fullCircle} style={{ backgroundColor: "green" }} />;
    }

    const { signatureSequence, isAllBuyerSigned, isAllSellerSigned, isAllBuyerAgentsSigned, isAllSellerAgentsSigned } = ele;

    const buyerRequired = !!signatureSequence?.[0]?.buyer;
    const sellerRequired = !!signatureSequence?.[0]?.seller;
    const buyerAgentRequired = !!signatureSequence?.[0]?.buyerAgent;
    const sellerAgentRequired = !!signatureSequence?.[0]?.sellerAgent;

    const clientRequired = buyerRequired || sellerRequired;
    const agentRequired = buyerAgentRequired || sellerAgentRequired;

    const isClientSigned =
      (!buyerRequired || isAllBuyerSigned) &&
      (!sellerRequired || isAllSellerSigned);

    const isAgentSigned =
      (!buyerAgentRequired || isAllBuyerAgentsSigned) &&
      (!sellerAgentRequired || isAllSellerAgentsSigned);

    const isAllSigned = isClientSigned && isAgentSigned;

    const isAnyClientSigned =
      (buyerRequired && isAllBuyerSigned) ||
      (sellerRequired && isAllSellerSigned);

    const isAnyAgentSigned =
      (buyerAgentRequired && isAllBuyerAgentsSigned) ||
      (sellerAgentRequired && isAllSellerAgentsSigned);

    const isAnySigned = isAnyClientSigned || isAnyAgentSigned;
    const anySignaturesRequired = clientRequired || agentRequired;

    if (anySignaturesRequired) {
      if (isAllSigned) {
        return <div className={styles.fullCircle} style={{ backgroundColor: "green" }} />;
      } else if (isAnySigned) {
        return <div className={styles.fullCircle} style={{ backgroundColor: "yellow" }} />;
      } else {
        return <div className={styles.fullCircle} style={{ backgroundColor: "white" }} />;
      }
    }
    return null;
  };


  const handleAddDocument = () => {
    setShowPropertyDocUpload(true)
  }

  const handleOpenLegendModal = () => {
    setShowLegend(true)
  }

  const handleUploadNew = (ele, scrollTo) => {
    if (scrollTo) scrollToIdRef.current = scrollTo;
    setAllData({
      ...allData,
      signatureOf: null,
      file: "",
      sourceOrigin: "CHECKLIST_UPLOAD_NEW",
      uploadPdfDoc: true,
      doraDocItem: ele,
    })
    dispatch(transactionLaneDataHandle.resetChecklistData())
  }

  const handleModalCancel = () => {
    setAllData({
      uploadPdfDoc: false,
      doraDocItem: {},
      sourceOrigin: "",
      source: "",
      signatureOf: null,
      file: ""
    })
  }

  useEffect(() => {
    let unmounted = { value: false }
    let source = axios.CancelToken.source();
    const params = {
      ...(item?.offerId && !item.isSellingMatrix ? { offerId: item?.offerId } : {}),
      ...(item?.propertyId ? { propertyId: item?.propertyId } : {}),
      openFor: client === "SELLER" ? "SELLER_AGENT" : "BUYER_AGENT",
      ...(delegate ? { delegateSide: (item.isProperty) ? "SELLER" : "BUYER", delegateOwnerId: currentAgentDetails?._id } : {}),
      section: "PROPERTY_DOCS",
      ...(isWeb ? { isWeb: true } : {}),
      queryPlatform: "WEB",
    };
    if (item?.offerId || item?.propertyId) {
      dispatch(PropertyHandlers.getPropertyDocsFun({ params, unmounted, source, scrollToIdRef }));
    }
    if(item?.offerId && origin === "PANEL_COMP"){
      dispatch(transactionLaneDataHandle.getTransactionLaneMethod({offerId: item?.offerId, role: client, unmounted, source, delegateSide, delegateOwnerId: delegate && currentAgentDetails?._id }));
    }
    dispatch(transactionLaneDataHandle.getChecklistData({ offerId: item?.offerId, propertyId: item?.propertyId, unmounted, source, delegateOwnerId: delegate && currentAgentDetails?._id, openFor: client === "SELLER" ? "SELLER" : "BUYER", scrollToIdRef }));
    dispatch(transactionLaneDataHandle.getSourceOfBusiness({ source, unmounted, scrollToIdRef }))
    return () => {
      unmounted.value = true;
      source.cancel("Cancelling in cleanup");
    }
  }, [updatedPropertyDoc, uploadedPdfDocSuccess, callCheckList])

  const handleClose = () => {
    setShowPropertyDocUpload(false);
    setCheckboxSelected([])
  }

  const handleVerify = (offerData, clicked, scrollTo) => {
    if (scrollTo) scrollToIdRef.current = scrollTo;
    dispatch(transactionLaneDataHandle.verifyUploadDoc({ clicked, offerData, signatureVerify: true }))
  }

  const urlShortningForDraft = (seller) => {
    if (seller?.ispdfClone || seller?.isPdf || (seller?.fileType === "IMAGE") || (seller?.fileType === "PDF") || (seller?.fileType === "EXCEL") || (seller?.fileType === "CSV") || (seller?.fileType === "ZIP") || seller?.pdfLink || seller?.fileUrl) {
      let fileUrl = seller?.resureSignedPdfLink ? seller?.resureSignedPdfLink : (seller?.pdfLink || seller?.fileUrl);
      window.open(fileUrl, "_blank").focus();
    } else {
      let buildData = {
        builtForId: currentAgentDetails?._id,
        key: currentAgentDetails?._id,
        builtForSection: "DOCUMENT",
        signable: true,
        openFor: client === "SELLER" ? "SELLER_AGENT" : "BUYER_AGENT",
        contractType: seller?.contractType,
        offerId: item?.offerId || null,
        documentId: seller?._id,
        contractId: seller?.contractId,
        token: localStorage.getItem("userAuth"),
        ...(delegate ? { delegateOwnerId: currentAgentDetails?._id } : {}),
      };
      dispatch(transactionLaneDataHandle.generateUrlIdAndRedirect({ buildData, currentPath: location?.pathname, delegateOwnerId: delegate && currentAgentDetails?._id }));
      if (origin === "PANEL_COMP") {       
        history.push(`${location?.pathname}?checklistOpen=true&id=${item?._id}`);
      } else {
        history.push(`${location?.pathname}?checklistOpen=true`);
      }
    }
  };

  const handleRemoveDocument = (offerData, clicked, scrollTo) => {
    if (scrollTo) scrollToIdRef.current = scrollTo;
    dispatch(transactionLaneDataHandle.verifyUploadDoc({ clicked, offerData, showInChecklist: false, remove: true, scrollTo }))
    dispatch(transactionLaneDataHandle.resetChecklistData())
  }

  const handleEditDoc = (ele, origin, scrollTo) => {
    if (scrollTo) scrollToIdRef.current = scrollTo;
    setAllData({ ...allData, uploadPdfDoc: true, file: origin === "add" ? ele?.fileName : ele?.name, signatureOf: ele?.signatureOf || [], doraDocItem: ele, sourceOrigin: "EDIT_CHECKLIST", scrollTo });
  };

  const MenuItem = ({ ele, origin, scrollTo }) => {
    const shouldShowVerify =
      (origin === "upload" && ele?.isPdf && !ele?.signaturesVerified) ||
      (origin === "add" && ele?.isPropertyDoc && !ele?.signaturesVerified);

    const canEdit = (origin === "upload" && (ele?.pdfLink || ele.fileUrl)) || (origin === "add" && ele?.isPropertyDoc);

    return (
      <Menu>
        {canEdit && (
          <Menu.Item key="edit" onClick={() => handleEditDoc(ele, origin, scrollTo)}>
            Assign Signatures
          </Menu.Item>
        )}
        <Menu.Item key="remove" onClick={() => handleRemoveDocument(ele, origin, scrollTo)}>
          Remove document
        </Menu.Item>
        {shouldShowVerify && (
          <Menu.Item key="verify" onClick={() => handleVerify(ele, origin, scrollTo)}>
            Mark required signatures complete
          </Menu.Item>
        )}
      </Menu>
    );
  };

  const handleShowInChecklist = (scrollTo) => {
    if (scrollTo) scrollToIdRef.current = scrollTo;
    const documentIds = checkboxSelected.map(({ check, doc }) => ({
      ...(doc?.fileUrl || doc?.isPropertyDoc
        ? { propertyDocId: doc?._id }
        : { documentId: doc?._id }),
      showInChecklist: !!check,
    }));
    // dispatch(transactionLaneDataHandle.verifyUploadDoc({ showInChecklist: true, checked: checked, clicked: (ele?.fileType === "PDF" || ele?.fileType === "IMAGE") ? "add" : "upload", offerData: ele }))
    dispatch(transactionLaneDataHandle.verifyUploadDoc({ documentIds }))
    setCheckboxSelected([]);
    setShowPropertyDocUpload(false)
    dispatch(transactionLaneDataHandle.resetChecklistData())
  }

  const handleSourceSelect = (e, scrollTo) => {
    if (scrollTo) scrollToIdRef.current = scrollTo;
    dispatch(transactionLaneDataHandle.updateSourceOfBusiness({ sourceOfBusiness: e?.key ? { key: e?.key } : {}, openFor: client, offerId: item?.offerId || null }, true))
  }

  const handleReferralAgent = (values, scrollTo) => {
    let urlData = {
      referringAgentDetails: {
        ...(values?.firmName?.length ? { firmName: values?.firmName } : {}),
        ...(values?.firmLicense?.length ? { firmLicense: values?.firmLicense } : {}),
        ...(values?.address?.length ? { address: values?.address } : {}),
        ...(values?.fullName?.length ? { fullName: values?.fullName } : {}),
        ...(values?.license?.length ? { license: values?.license } : {}),
        ...(values?.email?.length ? { email: values?.email } : {}),
        ...(values?.phoneNumber?.length ? { phoneNumber: values?.phoneNumber } : {}),
        ...(values?.faxNumber?.length ? { faxNumber: values?.faxNumber } : {}),
      }
    }
    if (scrollTo) scrollToIdRef.current = scrollTo;
    dispatch(transactionLaneDataHandle.updateReferringAgent({ urlData, openFor: client, offerId: item?.offerId || null, origin: "REFERRAL_AGENT" }))
    setAgent({ ...agent, referralSave: false })
  }

  const handleRenameDistribution = (values, scrollTo) => {
    setAddItems((prev) => ({
        ...prev,
        addedItems: [...(prev?.addedItems?.map(ele => (ele?.key === agent?.renamableItem?.key) ? {
            label: values?.renameLabel,
            name: values?.renameLabel,
            key: values?.renameLabel,
            custom: true,
          } : ele) || [])]
    }));
    dispatch(transactionLaneDataHandle.editDeleteOtherCommisionData({operation: "EDIT", oldKey: agent?.renamableItem?.key, newKey: values?.renameLabel}))
    dispatch(transactionLaneDataHandle.deleteDistribution({
      editOtherCommissionKey: {
        originalKey: agent?.renamableItem?.key,
        latestKey: values?.renameLabel
      },
      openFor: client,
      offerId: item?.offerId || null,
    }, true));
    if (scrollTo) scrollToIdRef.current = scrollTo;
  }


  const handleCommission = (values, scrollTo) => {
    const cleanedValues = {
      salePrice: cleanCurrency(values?.salePrice),
      grossCommission: cleanCurrency(values?.grossCommission),
    };

    const agents = client === "SELLER"
      ? transactionReportData?.sellerAgents || []
      : transactionReportData?.buyerAgents || [];

    const distributedCommission = {};
    const agentKeys = [];


    agents.forEach((agent, idx) => {
      const amountKey = `agentCommission${idx + 1}`;
      const percentKey = `agentCommissionPercentage${idx + 1}`;
      agentKeys.push(amountKey, percentKey);

      const amount = cleanCurrency(values?.[amountKey]);
      const percentage = values?.[percentKey];

      const agentEntry = {};
      if (amount !== undefined) agentEntry.amount = amount;
      if (percentage !== undefined) agentEntry.percentage = percentage;

      if (Object.keys(agentEntry).length > 0) {
        distributedCommission[agent?.fullName] = agentEntry;
      }
    });


    const brokerageAmount = cleanCurrency(values?.brokerage);
    const brokeragePercentage = values?.brokeragePercentage;
    if (brokerageAmount !== undefined || brokeragePercentage !== undefined) {
      distributedCommission.brokerage = {};
      if (brokerageAmount !== undefined) distributedCommission.brokerage.amount = brokerageAmount;
      if (brokeragePercentage !== undefined) distributedCommission.brokerage.percentage = brokeragePercentage;
    }

    const buyerAgentAmount = cleanCurrency(values?.buyerAgentCompliance);
    const buyerAgentCompliancePercentage = values?.buyerAgentCompliancePercentage;
    if (buyerAgentAmount !== undefined || buyerAgentCompliancePercentage !== undefined) {
      distributedCommission.buyerAgentCompliance = {};
      if (buyerAgentAmount !== undefined) distributedCommission.buyerAgentCompliance.amount = buyerAgentAmount;
      if (buyerAgentCompliancePercentage !== undefined) distributedCommission.buyerAgentCompliance.percentage = buyerAgentCompliancePercentage;
    }

    if (values?.totalCommission?.length) {
      distributedCommission.total = cleanCurrency(values?.totalCommission);
    }


    const otherCommission = {};

    const includeAsOther = (amountKey, percentKey, label) => {
      const amount = cleanCurrency(values?.[amountKey]);
      const percentage = values?.[percentKey];

      const entry = {};
      entry.amount = amount || "";
      entry.percentage = percentage || "";

      if (Object.keys(entry).length > 0) {
        otherCommission[label] = entry;
      }
    };


    includeAsOther("referral", "referralPercentage", "referral");

    const customItems = [
      ...(addItems?.addedItems || []),
      ...Object.entries(checkListDataOnOffer?.commissionDistribution?.otherCommission || {}).map(([key]) => ({ name: key })),
    ].filter(({ name }) => name !== "referral");

    customItems.forEach(({ name }) => {
      includeAsOther(name, `${name}Percentage`, name);
    });

    const urlData = {
      commissionDistribution: {
        ...(cleanedValues?.salePrice ? { salePrice: cleanedValues.salePrice } : {}),
        ...(cleanedValues?.grossCommission ? { grossCommission: cleanedValues.grossCommission } : {}),
        ...(values?.grossCommissionPercentage ? { grossCommissionPercentage: values.grossCommissionPercentage } : {}),
      },
      distributedCommission,
      otherCommission,
    };

    dispatch(transactionLaneDataHandle.updateCommissionReport({
      urlData,
      openFor: client,
      offerId: item?.offerId || null,
      origin: "COMMISSION_REPORT"
    }, true));

    setAgent({ ...agent, commissionSave: false });
  };

  const handleAddItemModal = () => {
    setAddItems({ ...addItems, addItemModalOpen: true })
  }

  const handleDownloadPdf = () => {
    // console.log(selectedFiles, "545")

  }

  useEffect(()=>{
    if (inputChangedRef.current) {
      handleBlurSave();
    }
  }, [addItems])

  useEffect(() => {
    if (checkListDataOnOffer?.referringAgentDetails) {
      referralForm?.setFieldsValue({
        firmName: checkListDataOnOffer.referringAgentDetails.firmName,
        firmLicense: checkListDataOnOffer.referringAgentDetails.firmLicense,
        address: checkListDataOnOffer.referringAgentDetails.address,
        fullName: checkListDataOnOffer.referringAgentDetails.fullName,
        license: checkListDataOnOffer.referringAgentDetails.license,
        phoneNumber: checkListDataOnOffer.referringAgentDetails.phoneNumber,
        faxNumber: checkListDataOnOffer.referringAgentDetails.faxNumber,
        email: checkListDataOnOffer.referringAgentDetails.email,
      });
    }

    if (checkListDataOnOffer?.commissionDistribution) {
      const distribution = checkListDataOnOffer.commissionDistribution;

      commissionForm?.setFieldsValue({
        salePrice: distribution?.salePrice,
        grossCommission: distribution?.grossCommission,
        grossCommissionPercentage: distribution?.grossCommissionPercentage,
      });

      if (distribution?.otherCommission) {
        const otherFields = {};

        Object.entries(distribution.otherCommission).forEach(([key, value]) => {
          if (typeof value === 'object' && value !== null) {
            if (value.amount !== undefined) {
              otherFields[key] = value.amount;
            }
            if (value.percentage !== undefined) {
              otherFields[`${key}Percentage`] = value.percentage;
            }
          } else {
            // fallback in case it's not the new object structure
            otherFields[key] = value;
          }
        });

        commissionForm?.setFieldsValue(otherFields);
      }

    }

    if (checkListDataOnOffer?.commissionDistribution?.distributedCommission) {
      const distributed = checkListDataOnOffer.commissionDistribution.distributedCommission;

      const agents = client === "SELLER"
        ? transactionReportData?.sellerAgents || []
        : transactionReportData?.buyerAgents || [];

      const agentFields = {};

      agents.forEach((_, idx) => {
        agentFields[`agentCommission${idx + 1}`] = undefined;
        agentFields[`agentCommissionPercentage${idx + 1}`] = undefined;
      });


      agents.forEach((agent, idx) => {
        const data = distributed?.[agent?.fullName];
        if (data) {
          if (data.amount !== undefined) {
            agentFields[`agentCommission${idx + 1}`] = data.amount;
          }
          if (data.percentage !== undefined) {
            agentFields[`agentCommissionPercentage${idx + 1}`] = data.percentage;
          }
        }
      });


      const specialKeys = ['brokerage', 'buyerAgentCompliance'];
      specialKeys.forEach((key) => {
        const value = distributed?.[key];
        if (value) {
          if (value.amount !== undefined) {
            agentFields[key] = value.amount;
          }
          if (value.percentage !== undefined) {
            agentFields[`${key}Percentage`] = value.percentage;
          }
        }
      });


      // if (distributed?.total !== undefined) {
      //   agentFields.totalCommission = distributed.total;
      // }

      commissionForm?.setFieldsValue(agentFields);
    }

    const distribution = checkListDataOnOffer?.commissionDistribution;
    let total = 0;

    if (distribution) {
      const excludeFromTotal = new Set(['salePrice', 'grossCommission', 'total']);

      const distributed = distribution?.distributedCommission || {};
      Object.entries(distributed).forEach(([key, value]) => {
        if (!excludeFromTotal.has(key) && typeof value === 'object' && value?.amount !== undefined) {
          const amount = +String(value.amount).replace(/[^\d.]/g, '');
          if (!isNaN(amount)) total += amount;
        }
      });


      const other = distribution?.otherCommission || {};
      Object.entries(other).forEach(([key, value]) => {
        if (typeof value === 'object' && value?.amount !== undefined) {
          const amount = +String(value.amount).replace(/[^\d.]/g, '');
          if (!isNaN(amount)) total += amount;
        }
      });

      const gross = +String(distribution?.grossCommission || 0).replace(/[^\d.]/g, '');

      commissionForm?.setFieldsValue({
        totalCommission: total.toFixed(2) || distribution?.distributedCommission?.total || "0",
      });
      if (gross > distribution?.distributedCommission?.total) {
        setShortfallAmount((gross - distribution?.distributedCommission?.total).toFixed(2));
      } else {
        setShortfallAmount(null);
      }

    }

  }, [checkListDataOnOffer,callCheckList]);


  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const isChecklistOpen = searchParams.get("checklistOpen") === "true";

    if (isChecklistOpen) {
      searchParams.delete("checklistOpen");
      searchParams.delete("id");
  
      history.replace(`${location.pathname}?${searchParams.toString()}`);
    }
  }, [])

  const generateValidIcon = (ele) => {
    return ele.fileType === "IMAGE" ? (
      <FileImageOutlined
        style={{
          color: "#ecd540",
          marginTop: "5px",
          marginRight: "5px",
          fontSize: "18px",
        }}
      />
    ) : ele.fileType === "ZIP" ? (
      <FaFileArchive
        style={{
          color: "#A0A0A0",
          marginTop: "5px",
          marginRight: "5px",
          fontSize: "18px",
        }}
      />
    ) : ele.fileType === "CSV" ? (
      <FaFileCsv
        style={{
          color: "#3F9E4D",
          marginTop: "5px",
          marginRight: "5px",
          fontSize: "18px",
        }}
      />
    ) : ele.fileType === "EXCEL" ? (
      <FaFileExcel
        style={{
          color: "#217346",
          marginTop: "5px",
          marginRight: "5px",
          fontSize: "18px",
        }}
      />
    ) : ele.fileType === "PDF" || ele.pdfLink || ele?.fileUrl ? (
      <FaRegFilePdf
        style={{
          color: "red",
          marginTop: "5px",
          marginRight: "5px",
          fontSize: "18px",
        }}
      />
    ) : (
      <FileTextOutlined
        style={{
          color: "#74b3ed",
          marginRight: "5px",
          fontSize: "18px",
        }}
      />
    )
  }

  const getAmountLimitChecker = (fieldName = 'grossCommission') => {
    return ({ floatValue }) => {
      const gross = +String(commissionForm?.getFieldValue(fieldName) || 0).replace(/[^\d.]/g, '');
      return floatValue === undefined || floatValue <= gross;
    };
  };

  const getPercentageLimitChecker = (currentField) => ({ floatValue }) => {
    if (floatValue === undefined) return true;

    const values = commissionForm?.getFieldsValue();
    let sum = 0;

    for (const [key, val] of Object.entries(values)) {
      if (
        key !== currentField && key !== "grossCommissionPercentage" &&
        key.toLowerCase().includes('percentage') &&
        !isNaN(+val)
      ) {
        sum += +String(val).replace(/[^\d.]/g, '');
      }
    }

    return sum + floatValue <= 100;
  };

  const handleBlurSave = () => {
    if (inputChangedRef.current) {
      handleCommission(commissionForm.getFieldsValue(), "commisionDistribution");
      inputChangedRef.current = false;
    }
  };

  
  const sectionIds = ['transactionSummary', 'tableChecklist', 'commisionDistribution'];

  const handleDownload = async () => {
    if(selectedZipFolder?.length > 0){
      dispatch(transactionLaneDataHandle.zipDownloadCheckList({
        data: {
          offerId: item?.offerId || null,
          propertyId: item?.propertyId,
          openFor: client,
          ...(delegate && { delegateOwnerId: currentAgentDetails?._id }),
        },
        address: transactionReportData?.address
      }));
    }
    else{
      if (!sectionIds.length) return;

      // Create printable container
      const printContainer = document.createElement('div');
      printContainer.id = 'print-container';
      printContainer.style.position = 'absolute';
      printContainer.style.top = '0';
      printContainer.style.left = '0';
      printContainer.style.width = '100%';
      printContainer.style.background = '#fff';
      printContainer.style.zIndex = '9999';
      printContainer.style.padding = '20px';
      printContainer.style.display = 'block';

      // Optional: add page-break styles
      const style = document.createElement('style');
      style.innerHTML = `
        @media print {
          html, body {
            background: #fff !important;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          #print-container {
            display: block;
            background: #fff !important;
            color-adjust: exact;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          .no-print {
            display: none !important;
          }

          .hideElementsBeforePrint{
            display: block;
          }

          #print-container > * {
            page-break-after: always;
            break-after: page;
          }
        }
      `;
      document.head.appendChild(style);

      // Clone selected sections
      sectionIds.forEach((id) => {
        if(!selectedFiles?.includes(id)) return;
        const el = document.getElementById(id);
        if (el) {
          const clone = el.cloneNode(true);
          printContainer.appendChild(clone);
        }
      });

      // Append to body
      document.body.appendChild(printContainer);

      // Hide everything else during print
      const originalBodyChildren = Array.from(document.body.children).filter(
        (el) => el.id !== 'print-container'
      );

      originalBodyChildren.forEach((el) => {
        el.style.display = 'none';
      });

      // Print
      window.print();

      // Restore everything after printing
      setTimeout(() => {
        printContainer.remove();
        style.remove();

        originalBodyChildren.forEach((el) => {
          el.style.display = '';
        });
      }, 1000);
    }
    setAgent({ ...agent, downloadModal: false });
  }

  const CommissionMenuItems = ({ele, scrollTo}) => {
    return (
      <Menu>
          <Menu.Item key="edit" onClick={() => handleEditName(ele, scrollTo)}>
            Edit Name
          </Menu.Item>
        <Menu.Item key="remove" onClick={() => handleDeleteItem(ele, scrollTo)}>
          Remove Item
        </Menu.Item>
      </Menu>
    );
  }

  const handleEditName = (ele, scrollTo) => {
    setAgent({...agent,renameModal: true, renamableItem: ele})
    renameForm?.setFieldsValue({renameLabel: ele?.key})
  }

  const handleDeleteItem = (field, scrollTo) => {
    Modal.confirm({
      title:`Are you sure you want to delete this ${field?.label}?`,
      okText: "Yes",
      cancelText:"No",
      onOk(){
        setAddItems((prev) => ({
          ...prev,
          addedItems: [...(prev?.addedItems?.filter(ele => (ele?.key !== field?.key)))]
        }));
        dispatch(transactionLaneDataHandle.editDeleteOtherCommisionData({operation: "DELETE", oldKey: field?.key }))
        dispatch(transactionLaneDataHandle.deleteDistribution({
          removeOtherCommissionKey:field?.key,
          openFor: client,
          offerId: item?.offerId || null,
        }, true));
        if (scrollTo) scrollToIdRef.current = scrollTo;
      },
      onCancel(){},
    })
  }

  const handleRename = () => {
    const values = renameForm?.getFieldsValue();
    const keyToFind = agent?.renamableItem?.key;
  
    const otherCommission = checkListDataOnOffer?.commissionDistribution?.otherCommission || {};
  
    const matchedEntry = Object.entries(otherCommission).find(
      ([key, value]) => key === keyToFind
    );
  
    if (matchedEntry) {
      const [matchedKey, matchedValue] = matchedEntry;
    } else {
      message.info("No matching data found!")
    }
  };

  return (
    <>
      <RtdLegend setShowLegend={setShowLegend} showlegend={showlegend} seller={client} sourceOrigin={"CHECKLIST"} />

      <UploadPdfDoc selectedData={{ ...allData.doraDocItem, RTDInitiator: client, ...item }} allData={allData} setAllData={setAllData} handleModalCancel={handleModalCancel} open={allData?.uploadPdfDoc} getCoordinateItem={{ isProperty: client === "SELLER" }} source={"checklistTable"} />

      <Modal open={agent.downloadModal} okText="Download" okButtonProps={{ disabled: !selectedZipFolder?.length && !selectedFiles?.length }} title={<span className='commonModalTitle'>Select Files to Download</span>} onOk={handleDownload} onCancel={() => setAgent({ ...agent, downloadModal: false })}>
        <div>
          <h3 style={{fontWeight: "700", textDecoration: "underline"}}>PDF Download/Print</h3>
          <div style={{marginLeft: "10px"}}>
            <Checkbox
              checked={allSelected}
              onChange={handleSelectAll}
              style={{ marginBottom: 12, fontWeight: "bold" }}
            >
              Select All
            </Checkbox>
            <Checkbox.Group
              options={fileOptions}
              value={selectedFiles}
              onChange={handleGroupChange}
              style={{ display: "flex", flexDirection: "column", gap: 10, paddingLeft: "10px" }}
            />
          </div>
          <div style={{display: "flex", alignItems: "center"}}>
            <div style={{width: "100%", borderTop: "2px solid #656565"}}></div>
            <div style={{padding: "0px 5px"}}> OR </div>
            <div style={{width: "100%", borderTop: "2px solid #656565"}}></div>
          </div>
          <h3 style={{fontWeight: "700", textDecoration: "underline"}}>ZIP Download</h3>
          <Checkbox.Group
            options={zipFileOptions}
            value={selectedZipFolder}
            onChange={handleZipChange}
            style={{ display: "flex", flexDirection: "column", gap: 10, paddingLeft: "10px" }}
          />
        </div>
      </Modal>

      <Modal open={agent.renameModal} okText="Yes" title={<span className='commonModalTitle'>Rename Distribution</span>} footer={false} onCancel={() => setAgent({ ...agent, renameModal: false, renamableItem: null })}>
        <Form form={renameForm} layout="vertical" onFinish={(e) => {handleRenameDistribution(e, "commission"); setAgent({ ...agent, renameModal: false, renamableItem: null });}}>
          <Form.Item
              label="Label"
              name="renameLabel"
              rules={[{ required: true, message: 'Please rename the label' }]}
          >
              <Input placeholder="Rename label" autoFocus/>
          </Form.Item>
          <Form.Item style={{ display: "flex", justifyContent: "center" }}>
            <Button type="primary" htmlType="submit">
              Save
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal open={checklistTable?.openTable} onCancel={handleCancel} width={1020} footer={false} style={{ marginTop: "-50px" }}
        title={
          <div style={{ position: 'relative', width: '100%', textAlign: 'center' }}>
            <span className="commonModalTitle">Compliance Checklist</span>
            <div style={{
              display: "flex", gap: "10px", position: 'absolute',
              right: 25,
              top: '10%'
            }}>
              {checklistMiniLoading && <div><Spin /></div>}
              <Tooltip title="Download pdf">
                <MdOutlineFileDownload onClick={() => setAgent({ ...agent, downloadModal: true })} style={{ cursor: "pointer", fontSize: "25px" }} />
              </Tooltip>
              <InfoCircleOutlined
                style={{
                  fontSize: "22px",
                  color: 'grey',
                  cursor: 'pointer',
                }}
                onClick={handleOpenLegendModal}
              />
            </div>
          </div>
        }
        bodyStyle={{
          height: "calc(84vh - 2rem)"
        }}>
        <div
          style={{
            position: "absolute",
            top: 50,
            left: 0,
            width: "100%",
            background: "#fff",
            zIndex: 100,
            padding: "10px 20px",
            borderBottom: "1px solid #ddd",
            display: "flex",
            justifyContent: "center",
            gap: "10px"
          }}
        >
          <Button onClick={() => scrollToSection(sectionRefs.TransactionSummary)}>Transaction Summary Report</Button>
          <Button onClick={() => scrollToSection(sectionRefs.ChecklistReport)}>Checklist Report</Button>
          <Button onClick={() => scrollToSection(sectionRefs.CommissionDistribution)}>Commission distribution Report</Button>
          {/* <Button onClick={() => scrollToSection(sectionRefs.ComplianceFiles)}>Compliance Files</Button> */}
        </div>


        <div style={{ position: "relative", height: "calc(80vh - 3.8rem)", overflowY: "auto", marginTop: "30px" }}>

          {checklistDataLoading ? (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "calc(80vh - 2rem)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1300,
              }}
            >
              <div>
                <Loading />
              </div>
            </div>
          ) :

            checklistData?.length > 0 ?
              <>
                <div id="transactionSummary">
                  <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "1rem", borderBottom: "1px solid #ccc", color: "white", background: "#2270B9", marginTop: "20px" }} ref={sectionRefs.TransactionSummary}>
                    TRANSACTION SUMMARY REPORT
                  </div>
                  <div>
                    {propertyInfo()}
                  </div>
                  <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "1rem", borderBottom: "1px solid #ccc", color: "white", background: "#2270B9" }}>
                    DATES
                  </div>
                  <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                    <table style={{ textAlign: "center", width: "100%", border: "1px solid black" }}>
                      <thead style={{ backgroundColor: "antiquewhite" }}>
                        <tr>
                          <th style={{ padding: "8px 16px" }}>Opening Date</th>
                          <th style={{ padding: "8px 16px" }}>Under Contract</th>
                          <th style={{ padding: "8px 16px" }}>Date of Transfer</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{transactionReportData?.openingDate}</td>
                          <td>{""}</td>
                          <td>{origin === "PANEL_COMP" ? formatDate(item?.closingDate) : item?.newTransactionData?.ClosingDate}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>


                  <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "1rem", borderBottom: "1px solid #ccc", color: "white", background: "#2270B9", marginTop: "20px" }}>
                    COMPANY INFORMATION
                  </div>
                  <div >
                    <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                      <div
                        style={{
                          display: "flex",
                          borderRadius: "8px",
                          overflow: "hidden",
                          width: "90%",
                          margin: "auto",
                          gap: "1px",
                        }}
                      >
                        {/* Seller Agents */}
                        <div style={{ flex: 1, padding: "16px", backgroundColor: "#f9f9f9" }}>
                          <div style={{ color: "orange", fontWeight: "bold", marginBottom: "12px" }}>
                            Listing Company
                          </div>

                          {transactionReportData?.sellerAgents?.map((agent, idx) => (
                            <div
                              key={`seller-${idx}`}
                              style={{
                                border: "1px solid #ddd",
                                borderRadius: "6px",
                                padding: "10px",
                                marginBottom: "16px",
                                backgroundColor: "#fff",
                              }}
                            >
                              {[
                                { label: "Brokerage Name:", value: agent?.firmName },
                                { label: "Brokerage ID:", value: agent?.firmLicense },
                                { label: "Address:", value: agent?.address },
                                { label: "Agent:", value: agent?.fullName },
                                { label: "Agent ID:", value: agent?.license },
                                { label: "Phone:", value: agent?.phoneNumber },
                                { label: "Fax:", value: agent?.faxNumber },
                                { label: "Email:", value: agent?.email },
                              ].map((field, index) => (
                                <div key={index} style={{ display: "flex", marginBottom: "6px" }}>
                                  <span style={{ fontWeight: "bold", width: "140px", flexShrink: 0 }}>
                                    {field.label}
                                  </span>
                                  <span>{field.value || ""}</span>
                                </div>
                              ))}
                            </div>
                          )
                          )}
                        </div>

                        {/* Divider */}
                        <div style={{ width: "1px", backgroundColor: "#ccc" }}></div>

                        {/* Buyer Agents */}
                        <div style={{ flex: 1, padding: "16px", backgroundColor: "#f9f9f9" }}>
                          <div style={{ color: "orange", fontWeight: "bold", marginBottom: "12px" }}>
                            Selling Company
                          </div>

                          {transactionReportData?.buyerAgents?.map((agent, idx) => (
                            <div
                              key={`buyer-${idx}`}
                              style={{
                                border: "1px solid #ddd",
                                borderRadius: "6px",
                                padding: "10px",
                                marginBottom: "16px",
                                backgroundColor: "#fff",
                              }}
                            >
                              {[
                                { label: "Brokerage Name:", value: agent?.firmName },
                                { label: "Brokerage ID:", value: agent?.firmLicense },
                                { label: "Address:", value: agent?.address },
                                { label: "Agent:", value: agent?.fullName },
                                { label: "Agent ID:", value: agent?.license },
                                { label: "Phone:", value: agent?.phoneNumber },
                                { label: "Fax:", value: agent?.faxNumber },
                                { label: "Email:", value: agent?.email },
                              ].map((field, index) => (
                                <div key={index} style={{ display: "flex", marginBottom: "6px" }}>
                                  <span style={{ fontWeight: "bold", width: "140px", flexShrink: 0 }}>
                                    {field.label}
                                  </span>
                                  <span>{field.value || ""}</span>
                                </div>
                              ))}
                            </div>
                          )
                          )}
                        </div>
                      </div>

                    </div>

                  </div>


                  <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "1rem", borderBottom: "1px solid #ccc", color: "white", background: "#2270B9", marginTop: "20px" }}>
                    BUYER INFORMATION
                  </div>

                  <div >

                    {transactionReportData?.buyerIds?.map((buyer, index) => {
                      const sourceArray = buyer.isCorp ? buyer.signers : [buyer];

                      return sourceArray.map((b, subIndex) => (
                        <div
                          key={`${index}-${subIndex}`}
                          style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              width: "90%",
                              border: "1px solid #ccc",
                              borderRadius: "8px",
                              overflow: "hidden",
                            }}
                          >
                            {/* Left Table */}
                            <div style={{ flex: 1, padding: "16px" }}>
                              <table style={{ width: "100%" }}>
                                <tbody>
                                  <tr>
                                    <td><strong>Buyer:</strong></td>
                                    <td>
                                      <input
                                        value={b?.fullName || ""}
                                        disabled
                                        style={{ width: "100%" }}
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td><strong>Email:</strong></td>
                                    <td>
                                      <input
                                        value={b?.personId?.email || ""}
                                        disabled
                                        style={{ width: "100%" }}
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td><strong>Address:</strong></td>
                                    <td>
                                      <textarea
                                        value={formatCLientAddress(b?.personId?.addressId) || ""}
                                        disabled
                                        style={{
                                          width: "100%",
                                          resize: "none",
                                          overflow: "hidden"
                                        }}
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>

                            {/* Divider */}
                            <div style={{ width: "1px", backgroundColor: "#ccc" }}></div>

                            {/* Right Table */}
                            <div style={{ flex: 1, padding: "16px" }}>
                              <table style={{ width: "100%" }}>
                                <tbody>
                                  <tr>
                                    <td><strong>Home Ph.:</strong></td>
                                    <td>
                                      <input
                                        value={formatPhoneNumber(b?.personId?.homePhoneNumber?.phoneNumber) || ""}
                                        disabled
                                        style={{ width: "100%" }}
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td><strong>Fax/Work:</strong></td>
                                    <td>
                                      <input
                                        value={formatPhoneNumber(b?.personId?.officePhoneNumber?.phoneNumber) || ""}
                                        disabled
                                        style={{ width: "100%" }}
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td><strong>Mobile Ph.:</strong></td>
                                    <td>
                                      <input
                                        value={formatPhoneNumber(b?.personId?.mobilePhoneNumber?.phoneNumber) || ""}
                                        disabled
                                        style={{ width: "100%" }}
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      ));
                    })}



                  </div>


                  <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "1rem", borderBottom: "1px solid #ccc", color: "white", background: "#2270B9", marginTop: "20px" }}>
                    SELLER INFORMATION
                  </div>

                  <div>
                    {transactionReportData?.sellerIds?.map((buyer, index) => {
                      const sourceArray = buyer.isCorp ? buyer.signers : [buyer];

                      return sourceArray.map((b, subIndex) => (
                        <div
                          key={`${index}-${subIndex}`}
                          style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              width: "90%",
                              border: "1px solid #ccc",
                              borderRadius: "8px",
                              overflow: "hidden",
                            }}
                          >
                            {/* Left Table */}
                            <div style={{ flex: 1, padding: "16px" }}>
                              <table style={{ width: "100%" }}>
                                <tbody>
                                  <tr>
                                    <td><strong>Seller:</strong></td>
                                    <td>
                                      <input
                                        value={b?.fullName || ""}
                                        disabled
                                        style={{ width: "100%" }}
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td><strong>Email:</strong></td>
                                    <td>
                                      <input
                                        value={b?.personId?.email || ""}
                                        disabled
                                        style={{ width: "100%" }}
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td><strong>Address:</strong></td>
                                    <td>
                                      <textarea
                                        value={formatCLientAddress(b?.personId?.addressId) || ""}
                                        disabled
                                        style={{
                                          width: "100%",
                                          resize: "none",
                                          overflow: "hidden"
                                        }}
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>

                            {/* Divider */}
                            <div style={{ width: "1px", backgroundColor: "#ccc" }}></div>

                            {/* Right Table */}
                            <div style={{ flex: 1, padding: "16px" }}>
                              <table style={{ width: "100%" }}>
                                <tbody>
                                  <tr>
                                    <td><strong>Home Ph.:</strong></td>
                                    <td>
                                      <input
                                        value={formatPhoneNumber(b?.personId?.homePhoneNumber?.phoneNumber) || ""}
                                        disabled
                                        style={{ width: "100%" }}
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td><strong>Fax/Work:</strong></td>
                                    <td>
                                      <input
                                        value={formatPhoneNumber(b?.personId?.officePhoneNumber?.phoneNumber) || ""}
                                        disabled
                                        style={{ width: "100%" }}
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td><strong>Mobile Ph.:</strong></td>
                                    <td>
                                      <input
                                        value={formatPhoneNumber(b?.personId?.mobilePhoneNumber?.phoneNumber) || ""}
                                        disabled
                                        style={{ width: "100%" }}
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      ));
                    })}

                  </div>


                  <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "1rem", borderBottom: "1px solid #ccc", color: "white", background: "#2270B9", marginTop: "20px" }}>
                    TITLE COMPANY INFORMATION
                  </div>

                  <div>
                    <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                      <div style={{ display: "flex", width: "90%", border: "1px solid #ccc", borderRadius: "8px", overflow: "hidden" }}>

                        {/* Left Table */}
                        <div style={{ flex: 1, padding: "16px" }}>
                          <table style={{ width: "100%" }}>
                            <tbody>
                              <tr>
                                <td><strong>Title Company:</strong></td>
                                <td>
                                  <input
                                    value={transactionReportData?.titleCompanyData?.titleOfficeName || transactionReportData?.titleCompanyData?.titleCompanyName || ""}
                                    disabled
                                    style={{ width: "100%" }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td><strong>Address:</strong></td>
                                <td>
                                  <textarea
                                    value={transactionReportData?.titleCompanyData?.titleOfficeAddress || ""}
                                    disabled
                                    style={{
                                          width: "100%",
                                          resize: "none",
                                          overflow: "hidden"
                                        }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td><strong>Phone:</strong></td>
                                <td>
                                  <input
                                    value={formatPhoneNumber(transactionReportData?.titleCompanyData?.titleOfficePhoneNo) || ""}
                                    disabled
                                    style={{ width: "100%" }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        {/* Divider */}
                        <div style={{ width: "1px", backgroundColor: "#ccc" }}></div>

                        {/* Right Table */}
                        <div style={{ flex: 1, padding: "16px" }}>
                          <table style={{ width: "100%" }}>
                            <tbody>
                              <tr>
                                <td><strong>Closer:</strong></td>
                                <td>
                                  <input
                                    value={transactionReportData?.titleCompanyData?.titleCloserName || ""}
                                    disabled
                                    style={{ width: "100%" }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td><strong>Closer Address:</strong></td>
                                <td>
                                  <textarea
                                    value={transactionReportData?.titleCompanyData?.titleCloserAddress || ""}
                                    disabled
                                    style={{
                                      width: "100%",
                                      resize: "none",
                                      overflow: "hidden"
                                    }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td><strong>Closer Ph:</strong></td>
                                <td>
                                  <input
                                    value={formatPhoneNumber(transactionReportData?.titleCompanyData?.titleCloserPhone) || ""}
                                    disabled
                                    style={{ width: "100%" }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                      </div>
                    </div>

                  </div>
                </div>


                <div style={{
                  height: "2px",
                  backgroundColor: "black",
                  width: "100%",
                  margin: "30px 0 10px 0"
                }} />

                <div id="tableChecklist">
                  <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "1rem", borderBottom: "1px solid #ccc", color: "white", background: "#2270B9", marginTop: "20px" }} ref={sectionRefs.ChecklistReport}>
                    CHECKLIST REPORT
                  </div>
                  <table border="2" style={{ width: "100%", margin: "20px 0 20px 0" }} id="tableChecklist">
                    <thead className="licenseTable">
                      <tr style={{ backgroundColor: "" }}>
                        <th colSpan="3" style={{ textAlign: "center" }}>Transaction Documents</th>
                        <th colSpan="4" style={{ textAlign: "center" }}>Signatures</th>
                        <th colspan="1" style={{ textAlign: "center" }}>Status</th>
                      </tr>
                      <tr>
                        <th style={{ borderTop: "1px solid black" }}>Created/Uploaded Date</th>
                        <th style={{ borderTop: "1px solid black" }}>Completed/Verified Date</th>
                        <th>Documents</th>
                        <th>Buyer(s)</th>
                        <th>Buyer Agent(s)</th>
                        <th>Seller(s)</th>
                        <th>Seller Agent(s)</th>
                        <th style={{ borderTop: "1px solid black" }}>Complete</th>
                      </tr>
                    </thead>
                    <tbody style={{ textAlign: "center" }}>
                      {checklistData?.map((ele, idx) => {
                        const isUpload = ele?.isUpload || false;
                        if (!ele?.isPropertyDoc) {
                          return (
                            <tr key={ele.contractId}>
                              <td>{ele?.createdAt ? moment(ele?.createdAt)?.format("MM/DD/YYYY hh:mm A") : ""}</td>
                              <td>{!isUpload && ele?.latestSignatureTimeStamp ? moment(ele?.latestSignatureTimeStamp)?.format("MM/DD/YYYY hh:mm A") : ele?.signaturesVerified && ele?.signaturesVerifiedAt ? moment(ele?.signaturesVerifiedAt)?.format("MM/DD/YYYY hh:mm A") : ""}</td>
                              <td>
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                  {generateValidIcon(ele)}
                                  <span className={!isUpload ? styles.documentName : ""} style={{ margin: "0 auto", cursor: !isUpload ? "pointer" : "" }} onClick={isUpload ? undefined : () => urlShortningForDraft(ele)}>
                                    {ele?.updatedName ? ele?.updatedName?.trim() : ele?.name}
                                    {ele?.updatedName && (
                                      <>
                                        <br />
                                        <span
                                          style={{
                                            fontSize: isSmallScreen ? "11px" : "13px",
                                            color: "grey",
                                          }}
                                        >
                                          ({ele?.name})
                                        </span>
                                      </>
                                    )}
                                  </span>
                                  {isUpload && <IoCloudUploadOutline className="no-print" onClick={() => handleUploadNew(ele, "tableChecklist")} style={{ fontSize: "18px", cursor: "pointer", marginLeft: "5px" }} />}
                                  {!isUpload && (
                                    <Dropdown className="no-print" overlay={<MenuItem ele={ele} isUpload={isUpload} origin="upload" scrollTo="tableChecklist" />} trigger={["click", "hover"]}>
                                      <MoreOutlined style={{ cursor: "pointer", fontSize: "26px", strokeWidth: "2", color: "#085190" }} />
                                    </Dropdown>
                                  )}
                                </div>
                              </td>
                              <td>
                                {(ele?.signatureSequence?.[0]?.buyer && ele?.isAllBuyerSigned) || ele?.signatureOf?.includes("BUYER")
                                  ? "✔️"
                                  : !isUpload && (!ele?.signatureSequence?.[0]?.buyer || ele?.signatureOf?.includes("BUYER"))
                                    ? "n/a"
                                    : ""}
                              </td>
                              <td>
                                {(ele?.signatureSequence?.[0]?.buyerAgent && ele?.isAllBuyerAgentsSigned) || ele?.signatureOf?.includes("BUYER_AGENT")
                                  ? "✔️"
                                  : !isUpload && (!ele?.signatureSequence?.[0]?.buyerAgent || ele?.signatureOf?.includes("BUYER_AGENT"))
                                    ? "n/a"
                                    : ""}
                              </td>
                              <td>
                                {(ele?.signatureSequence?.[0]?.seller && ele?.isAllSellerSigned) || ele?.signatureOf?.includes("SELLER")
                                  ? "✔️"
                                  : !isUpload && (!ele?.signatureSequence?.[0]?.seller || ele?.signatureOf?.includes("SELLER"))
                                    ? "n/a"
                                    : ""}
                              </td>
                              <td>
                                {(ele?.signatureSequence?.[0]?.sellerAgent && ele?.isAllSellerAgentsSigned) || ele?.signatureOf?.includes("SELLER_AGENT")
                                  ? "✔️"
                                  : !isUpload && (!ele?.signatureSequence?.[0]?.sellerAgent || ele?.signatureOf?.includes("SELLER_AGENT"))
                                    ? "n/a"
                                    : ""}
                              </td>

                              <td className={styles.symbolsColumn}>{ele ? getStatusIcon(ele, isUpload) : ""}</td>
                            </tr>
                          );
                        }
                        return (
                          <tr key={ele.contractId}>
                            <td>{ele?.createdAt ? moment(ele?.createdAt)?.format("MM/DD/YYYY hh:mm A") : ele?.createdAt ? moment(ele?.createdAt)?.format("MM/DD/YYYY hh:mm A") : ""}</td>
                            <td>{ele?.signaturesVerifiedAt ? moment(ele?.signaturesVerifiedAt)?.format("MM/DD/YYYY hh:mm A") : ""}</td>
                            <td>
                              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                {generateValidIcon(ele)}
                                <span className={ele?.isPropertyDoc ? styles.documentName : ""} style={{ margin: "0 auto", cursor: ele?.isPropertyDoc ? "pointer" : "" }} onClick={ele?.isPropertyDoc ? () => urlShortningForDraft(ele) : undefined}>{ele?.name || ele?.fileName}</span>
                                {isUpload && <IoCloudUploadOutline onClick={() => handleUploadNew(ele, "tableChecklist")} style={{ fontSize: "18px", cursor: "pointer" }} className="no-print"/>}
                                {!isUpload && <Dropdown className="no-print" overlay={<MenuItem ele={ele} origin="add" scrollTo="tableChecklist" />} trigger={["click", "hover"]}>
                                  <MoreOutlined style={{ cursor: "pointer", fontSize: "26px", strokeWidth: "2", color: "#085190" }} />
                                </Dropdown>}

                              </div>
                            </td>
                            <td>
                              {(ele?.signatureOf?.includes("BUYER")) ? "✔️" : "n/a"}
                            </td>
                            <td>
                              {(ele?.signatureOf?.includes("BUYER_AGENT"))
                                ? "✔️"
                                : "n/a"}
                            </td>
                            <td>
                              {(ele?.signatureOf?.includes("SELLER")) ? "✔️" : "n/a"}
                            </td>
                            <td>
                              {(ele?.signatureOf?.includes("SELLER_AGENT"))
                                ? "✔️"
                                : "n/a"}
                            </td>
                            <td className={styles.symbolsColumn}>
                              {ele?.signaturesVerified ? getStatusIcon(ele) : ""}
                            </td>
                          </tr>
                        );
                      })}
                      <tr style={{ textAlign: "left" }}>
                        <td></td>
                        <td></td>
                        <td>
                          <Button style={{ margin: "5px 10px" }} type='primary' onClick={handleAddDocument} className="no-print">Add Document</Button>
                        </td>
                        <td colSpan={5}></td>
                      </tr>
                    </tbody>


                    {showPropertyDocUpload && <Modal
                      title={<span style={{ display: "flex", justifyContent: "center", color: "#178DFA", fontWeight: "bold", fontSize: "22px" }}>Add Documents</span>}
                      visible={true}
                      width={770}
                      bodyStyle={{ height: "calc(80vh - 3rem)" }}
                      onCancel={handleClose}
                      footer={false}
                    >
                      <Tabs defaultActiveKey="propertyDocs" style={{ marginTop: "-25px" }}>
                        <TabPane tab="Property Docs" key="propertyDocs">
                          {propertDocsLoading ? <Loading /> :
                            <>
                              <div style={{ textAlign: "center", height: "calc(80vh - 10rem)", overflowY: "auto" }}>
                                <PropertyDocsTable origin={"checklistTable"} propertyDocs={propertyDocs} role={client} item={item} handleShowInChecklist={handleShowInChecklist} checkboxSelected={checkboxSelected} setCheckboxSelected={setCheckboxSelected} />
                              </div>
                              {checkboxSelected?.length > 0 && <div style={{ display: "flex", justifyContent: "center", marginBottom: 8 }}>
                                <Button type="primary" onClick={() => handleShowInChecklist("tableChecklist")}>
                                  Apply
                                </Button>
                              </div>}
                            </>
                          }
                        </TabPane>
                        <TabPane tab="Upload" key="upload">
                          <PropertyDocsDragger handleClose={handleClose} item={{ ...item, ...((client === "SELLER") ? { isProperty: true } : { isOffer: true }) }} delegate={delegate} additionalData={{ showInChecklist: true }} origin={"checklistTable"} />
                        </TabPane>
                      </Tabs>
                    </Modal>}
                  </table>
                </div>

                <div style={{
                  height: "2px",
                  backgroundColor: "black",
                  width: "100%",
                  margin: "30px 0 10px 0"
                }} />

                <div id="commisionDistribution">
                <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "1rem", borderBottom: "1px solid #ccc", marginTop: "20px" }} ref={sectionRefs.CommissionDistribution}>
                  <div>Commission Distribution Report from Sale ({client === "SELLER" ? "Seller's" : "Buyer's"} Agent)</div>
                  <div>{transactionReportData?.address}</div>
                </div>
                <div >
                  <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                    <div
                      style={{
                        display: "flex",
                        borderRadius: "8px",
                        overflow: "hidden",
                        width: "100%",
                        margin: "auto",
                        gap: "1px",
                      }}
                    >
                      {/* Seller Agents */}
                      <div style={{ flex: 1, padding: "16px", backgroundColor: "#f9f9f9" }}>
                        <div style={{ color: "grey", fontWeight: "bold", marginBottom: "12px", textAlign: "center" }}>
                          {client === "SELLER" ? "Selling" : "Buying"} Agent
                        </div>

                        {(client === "SELLER" ? transactionReportData?.sellerAgents : transactionReportData?.buyerAgents)?.map((agent, idx) => (
                          <div
                            key={`seller-${idx}`}
                            style={{
                              border: "1px solid #ddd",
                              borderRadius: "6px",
                              padding: "10px",
                              marginBottom: "16px",
                              backgroundColor: "#fff",
                            }}
                          >
                            {[
                              { label: "Brokerage Name:", value: agent?.firmName },
                              { label: "Brokerage ID:", value: agent?.firmLicense },
                              { label: "Address:", value: agent?.address },
                              { label: "Agent:", value: agent?.fullName },
                              { label: "Agent ID:", value: agent?.license },
                              { label: "Phone:", value: agent?.phoneNumber },
                              { label: "Fax:", value: agent?.faxNumber },
                              { label: "Email:", value: agent?.email },
                            ].map((field, index) => (
                              <div key={index} style={{ display: "flex", marginBottom: "6px" }}>
                                <span style={{ fontWeight: "bold", width: "140px", flexShrink: 0 }}>
                                  {field.label}
                                </span>
                                <span>{field.value || ""}</span>
                              </div>
                            ))}
                          </div>
                        )
                        )}
                      </div>

                      {/* Divider */}
                      <div style={{ width: "1px", backgroundColor: "#ccc" }}></div>

                      <div style={{ flex: 1, padding: "16px", backgroundColor: "#f9f9f9" }} id="referringAgent">
                        <div style={{ color: "grey", fontWeight: "bold", marginBottom: "12px", textAlign: "center" }}>
                          Referring Agent (optional)
                        </div>

                        <Form
                          form={referralForm}
                          layout="horizontal"
                          onValuesChange={(values) => setAgent({ ...agent, referralSave: true })}
                          onFinish={(e) => handleReferralAgent(e, "referringAgent")}
                          labelCol={{ span: 8 }}
                          wrapperCol={{ span: 16 }}
                        >
                          <div
                            style={{
                              border: "1px solid #ddd",
                              borderRadius: "6px",
                              padding: "5px",
                              marginBottom: "16px",
                              backgroundColor: "#fff",
                            }}
                          >
                            <Form.Item
                              label={<span style={{ fontSize: "14px" }}>Brokerage Name:</span>}
                              name="firmName"
                              style={{ marginBottom: "5px" }}
                            >
                              <Input />
                            </Form.Item>

                            <Form.Item
                              label={<span style={{ fontSize: "14px" }}>Brokerage ID:</span>}
                              name="firmLicense"
                              style={{ marginBottom: "5px" }}
                            >
                              <Input />
                            </Form.Item>

                            <Form.Item
                              label={<span style={{ fontSize: "14px" }}>Address:</span>}
                              name="address"
                              style={{ marginBottom: "5px" }}
                            >
                              <Input />
                            </Form.Item>

                            <Form.Item
                              label={<span style={{ fontSize: "14px" }}>Agent:</span>}
                              name="fullName"
                              style={{ marginBottom: "5px" }}
                            >
                              <Input />
                            </Form.Item>

                            <Form.Item
                              label={<span style={{ fontSize: "14px" }}>Agent ID:</span>}
                              name="license"
                              style={{ marginBottom: "5px" }}
                            >
                              <Input />
                            </Form.Item>

                            <Form.Item
                              label={<span style={{ fontSize: "14px" }}>Phone:</span>}
                              name="phoneNumber"
                              style={{ marginBottom: "5px" }}
                            >
                              <PhoneInput
                                inputStyle={{
                                  width: "100%",
                                }}
                                inputClass="phoneInput"
                                country={"us"}
                                onlyCountries={["us"]}
                                maxLength="10"
                                international={false}
                                disableCountryCode={true}
                                placeholder=""
                              />
                            </Form.Item>

                            <Form.Item
                              label={<span style={{ fontSize: "14px" }}>Fax:</span>}
                              name="faxNumber"
                              style={{ marginBottom: "5px" }}
                            >
                              <PhoneInput
                                inputStyle={{
                                  width: "100%",
                                }}
                                inputClass="phoneInput"
                                country={"us"}
                                onlyCountries={["us"]}
                                maxLength="10"
                                international={false}
                                disableCountryCode={true}
                                placeholder=""
                              />
                            </Form.Item>

                            <Form.Item
                              label={<span style={{ fontSize: "14px" }}>Email:</span>}
                              name="email"
                              style={{ marginBottom: "5px" }}
                            >
                              <Input />
                            </Form.Item>
                          </div>
                          <Form.Item style={{ display: "flex", justifyContent: "center" }}>
                            <Button type="primary" htmlType="submit" disabled={!agent?.referralSave} className="no-print">
                              Save
                            </Button>
                          </Form.Item>
                        </Form>


                      </div>
                    </div>

                  </div>

                </div>



                <div style={{ padding: '15px', width: "70%" }} id="sourceOfBuisness">
                  <Form>
                    <Form.Item label="Source Of Business" name="sourceOfBusiness">
                      <Select
                        labelInValue
                        onChange={(e) => handleSourceSelect(e, "sourceOfBuisness")}
                        loading={sourceOfBusinessLoading}
                        notFoundContent={
                          sourceOfBusinessLoading ? <Loading /> : <EmptyData />
                        }
                        showSearch
                        filterOption={(input, option) =>
                          option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
                        }
                        className="no-print"
                        defaultValue={checkListDataOnOffer?.sourceOfBusiness?.key}
                      >
                        {sourceOfBusinessData?.length > 0 && sourceOfBusinessData?.map((element, index) => (
                          <Option key={element?.key} value={element?.key}>
                            {element?.value}
                          </Option>
                        ))
                        }
                      </Select>
                      <div className='hideElementsBeforePrint' style={{ fontSize: "17px", fontWeight: "600" }}>{checkListDataOnOffer?.sourceOfBusiness?.value}</div>
                    </Form.Item>
                  </Form>
                </div>



                <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "1rem", borderBottom: "1px solid #ccc", color: "white", background: "#2270B9" }}>
                  DATES
                </div>
                <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                  <table style={{ textAlign: "center", width: "100%", border: "1px solid black" }}>
                    <thead style={{ backgroundColor: "antiquewhite" }}>
                      <tr>
                        <th style={{ padding: "8px 16px" }}>Opening Date</th>
                        <th style={{ padding: "8px 16px" }}>Under Contract</th>
                        <th style={{ padding: "8px 16px" }}>Closing Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{transactionReportData?.openingDate}</td>
                        <td>{""}</td>
                        <td>{origin === "PANEL_COMP" ? formatDate(item?.closingDate) : item?.newTransactionData?.ClosingDate}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                
                  <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "1rem", borderBottom: "1px solid #ccc", color: "white", background: "#2270B9", marginTop: "20px" }}>
                    COMMISSION DISTRIBUTION
                  </div>

                  <div className={styles1.commissionForm} id="commission">
                    <Form
                      form={commissionForm}
                      // onFinish={(e) => handleCommission(e, "commisionDistribution")}

                      onValuesChange={(changedValues, allValues) => {
                        setAgent({ ...agent, commissionSave: true });
                        inputChangedRef.current = true;

                        const rawSalePrice = +String(allValues.salePrice || 0).replace(/[^\d.]/g, '');
                        const rawGrossCommission = +String(allValues.grossCommission || 0).replace(/[^\d.]/g, '');
                        const rawGrossCommissionPercentage = +String(allValues.grossCommissionPercentage || 0).replace(/[^\d.]/g, '');


                        if ('grossCommissionPercentage' in changedValues && rawSalePrice) {
                          const updated = (rawSalePrice * rawGrossCommissionPercentage) / 100;
                          commissionForm.setFieldsValue({ grossCommission: updated.toFixed(2) });
                        } else if ('grossCommission' in changedValues && rawSalePrice) {
                          const updated = (rawGrossCommission / rawSalePrice) * 100;
                          commissionForm.setFieldsValue({ grossCommissionPercentage: updated.toFixed(2) });
                        } else if ('salePrice' in changedValues && rawSalePrice) {
                          if (rawGrossCommissionPercentage) {
                            commissionForm.setFieldsValue({
                              grossCommission: ((rawSalePrice * rawGrossCommissionPercentage) / 100).toFixed(2),
                            });
                          } else if (rawGrossCommission) {
                            commissionForm.setFieldsValue({
                              grossCommissionPercentage: ((rawGrossCommission / rawSalePrice) * 100).toFixed(2),
                            });
                          }
                        }


                        const syncPercentAmount = (percentKey, amountKey) => {
                          if (percentKey in changedValues) {
                            const rawPercent = +String(allValues[percentKey] || 0).replace(/[^\d.]/g, '');
                            if (rawGrossCommission) {
                              const updatedAmount = (rawGrossCommission * rawPercent) / 100;
                              commissionForm.setFieldsValue({ [amountKey]: updatedAmount.toFixed(2) });
                            }
                          }

                          if (amountKey in changedValues) {
                            setTimeout(() => {
                              const newValues = commissionForm.getFieldsValue();
                              const rawAmount = +String(newValues[amountKey] || 0).replace(/[^\d.]/g, '');
                              if (rawGrossCommission) {
                                const updatedPercent = (rawAmount / rawGrossCommission) * 100;
                                commissionForm.setFieldsValue({ [percentKey]: updatedPercent.toFixed(2) });
                              }
                            }, 0);
                          }
                        };


                        const agents = client === 'SELLER'
                          ? transactionReportData?.sellerAgents || []
                          : transactionReportData?.buyerAgents || [];

                        agents.forEach((_, idx) => {
                          syncPercentAmount(`agentCommissionPercentage${idx + 1}`, `agentCommission${idx + 1}`);
                        });

                        if(client === 'SELLER'){
                          syncPercentAmount('buyerAgentCompliancePercentage', 'buyerAgentCompliance');
                        }
                        else{
                          syncPercentAmount('brokeragePercentage', 'brokerage');
                        }

                        syncPercentAmount('referralPercentage', 'referral');


                        const customItems = [
                          ...(addItems?.addedItems || []),
                          ...Object.entries(checkListDataOnOffer?.commissionDistribution?.otherCommission || {}).map(([key]) => ({ name: key })),
                        ];

                        customItems
                          .filter(({ name }) => name !== 'referral')
                          .forEach(({ name }) => {
                            syncPercentAmount(`${name}Percentage`, name);
                          });


                        setTimeout(() => {
                          const values = commissionForm.getFieldsValue();

                          let total = 0;
                          const excludedKeys = new Set([
                            'salePrice',
                            'grossCommission',
                            'grossCommissionPercentage',
                            'totalCommission',
                          ]);

                          Object.entries(values).forEach(([key, val]) => {
                            if (
                              excludedKeys.has(key) ||
                              key.toLowerCase().includes('percentage')
                            ) return;

                            const num = +String(val).replace(/[^\d.]/g, '');
                            if (!isNaN(num)) total += num;
                          });

                          commissionForm.setFieldsValue({ totalCommission: total.toFixed(2) });
                          const gross = +String(values.grossCommission || 0).replace(/[^\d.]/g, '');
                          const totalAmount = +String(values.totalCommission || 0).replace(/[^\d.]/g, '');

                          const shortfall = gross > totalAmount ? (gross - totalAmount).toFixed(2) : null;

                          setShortfallAmount(shortfall);

                        }, 0);
                      }}


                      layout="horizontal"
                      style={{ padding: "2px", width: "100%" }}
                      labelCol={{ span: 17 }}
                      wrapperCol={{ span: 7 }}
                    >
                      <Form.Item
                        label={<span style={{ fontSize: "17px" }}>Sales Price</span>}
                        rules={[
                          {
                            validator: (_, value) => {
                              const numericValue = +String(value || '').replace(/[^\d.]/g, '');
                              if (numericValue === 0) {
                                return Promise.reject(new Error('Sales Price cannot be 0'));
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                        className={styles1.formItem}
                      >
                        <div className={styles1.input_with_symbol}>
                          <span className={styles1.symbol}>$ </span>
                          <Form.Item name="salePrice" noStyle>
                            <NumberFormat
                              className={`newNumberInput ${styles1.input}`}
                              inputMode="numeric"
                              thousandSeparator
                              allowNegative={false}
                              readOnly
                              customInput={Input}
                            />
                          </Form.Item>
                        </div>
                      </Form.Item>

                      <Form.Item
                        label={
                          <div style={{ fontSize: "17px", display: "flex", gap: "5px" }}>
                            Gross Commission
                            {((client === "BUYER" && Object.keys(checkListDataOnOffer?.commissionDistribution?.grossCommissionsInOffer || {}).length > 0) || client === "SELLER") && (
                              <div style={{ display: "flex", alignItems: "center", color: "#faad14", marginTop: "2px", fontSize: "12px" }}>
                                <Tooltip
                                  title={
                                    client === "BUYER"
                                      ? "Please check section 29 of the offer document and update accordingly."
                                      : "Please check section 7 of the erts document and update accordingly."
                                  }
                                >
                                  <ExclamationCircleOutlined style={{ fontSize: "16px", marginTop: "-4px" }} />
                                </Tooltip>
                              </div>
                            )}
                            {additionalData?.ertsGrossCommissionPercentage && <div> - ERTS Section 7: {additionalData?.ertsGrossCommissionPercentage}%</div>}
                          </div>
                        }
                        className={`${styles1.formItem} ${styles1.darkerLine}`}
                      >
                        <div className={styles1.rowGroup}>
                          <Form.Item style={{ width: "30%" }} className={styles1.percentCol}>
                            <div className={styles1.input_with_symbol}>
                              <span className={styles1.symbol}>% </span>
                              <Form.Item name="grossCommissionPercentage" noStyle>
                                <NumberFormat
                                  className={`newNumberInput ${styles1.input}`}
                                  inputmode="numeric"
                                  displayType={"number"}
                                  // suffix={"%"}
                                  allowNegative={false}
                                  isAllowed={({ floatValue }) => floatValue === undefined || floatValue <= 100}
                                  onBlur={handleBlurSave}
                                  readOnly={
                                    !!checkListDataOnOffer?.commissionDistribution?.grossCommission ||
                                    !!checkListDataOnOffer?.commissionDistribution?.grossCommissionPercentage
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Form.Item>
                          <Form.Item style={{ width: "70%" }} className={styles1.amountCol}>
                            <div className={styles1.input_with_symbol}>
                              <span className={styles1.symbol}>$ </span>
                              <Form.Item name="grossCommission" noStyle>
                                <NumberFormat
                                  className={`newNumberInput ${styles1.input}`}
                                  inputmode="numeric"
                                  displayType={"number"}
                                  thousandSeparator={true}
                                  allowNegative={false}
                                  isAllowed={({ floatValue }) => {
                                    const grossCommission = +String(commissionForm.getFieldValue('salePrice') || 0).replace(/[^\d.]/g, '');
                                    return floatValue === undefined || floatValue <= grossCommission;
                                  }}
                                  onBlur={handleBlurSave}
                                  readOnly={
                                    !!checkListDataOnOffer?.commissionDistribution?.grossCommission ||
                                    !!checkListDataOnOffer?.commissionDistribution?.grossCommissionPercentage
                                  }
                                />
                              </Form.Item>
                            </div>
                          </Form.Item>
                        </div>
                      </Form.Item>

                      {client === "BUYER" ? <Form.Item
                        label={<span style={{ fontSize: "17px" }}>Brokerage</span>}
                        className={styles1.formItem}
                      >
                        <div className={styles1.rowGroup}>
                          <Form.Item style={{ width: "30%" }} className={styles1.percentCol}>
                            <div className={styles1.input_with_symbol}>
                              <span className={styles1.symbol}>% </span>
                              <Form.Item name="brokeragePercentage" noStyle>
                                <NumberFormat
                                  className={`newNumberInput ${styles1.input}`}
                                  inputmode="numeric"
                                  displayType={"number"}
                                  allowNegative={false}
                                  isAllowed={getPercentageLimitChecker('brokeragePercentage')}
                                  onBlur={handleBlurSave}
                                />
                              </Form.Item>
                            </div>
                          </Form.Item>
                          <Form.Item style={{ width: "70%" }} className={styles1.amountCol}>
                            <div className={styles1.input_with_symbol}>
                              <span className={styles1.symbol}>$ </span>
                              <Form.Item name="brokerage" noStyle>
                                <NumberFormat
                                  className={`newNumberInput ${styles1.input}`}
                                  inputmode="numeric"
                                  displayType={"number"}
                                  thousandSeparator={true}
                                  allowNegative={false}
                                  isAllowed={getAmountLimitChecker()}
                                  onBlur={handleBlurSave}
                                />
                              </Form.Item>
                            </div>
                          </Form.Item>
                        </div>
                      </Form.Item> : <>

                        <Form.Item
                        label={<span style={{ fontSize: "17px" }}>Buyer Agent Commission</span>}
                        className={styles1.formItem}
                      >
                        <div className={styles1.rowGroup}>
                          <Form.Item style={{ width: "30%" }} className={styles1.percentCol}>
                            <div className={styles1.input_with_symbol}>
                              <span className={styles1.symbol}>% </span>
                              <Form.Item name="buyerAgentCompliancePercentage" noStyle>
                                <NumberFormat
                                  className={`newNumberInput ${styles1.input}`}
                                  inputmode="numeric"
                                  displayType={"number"}
                                  allowNegative={false}
                                  isAllowed={getPercentageLimitChecker('buyerAgentCompliancePercentage')}
                                  onBlur={handleBlurSave}
                                />
                              </Form.Item>
                            </div>
                          </Form.Item>
                          <Form.Item style={{ width: "70%" }} className={styles1.amountCol}>
                            <div className={styles1.input_with_symbol}>
                              <span className={styles1.symbol}>$ </span>
                              <Form.Item name="buyerAgentCompliance" noStyle>
                                <NumberFormat
                                  className={`newNumberInput ${styles1.input}`}
                                  inputmode="numeric"
                                  displayType={"number"}
                                  thousandSeparator={true}
                                  allowNegative={false}
                                  isAllowed={getAmountLimitChecker()}
                                  onBlur={handleBlurSave}
                                />
                              </Form.Item>
                            </div>
                          </Form.Item>
                        </div>
                        </Form.Item>
                      </>
                      }

                      <Form.Item label={<span style={{ fontSize: "17px" }}>{client === "SELLER" ? "Seller Agent Commission" : "Agents"}</span>} className={styles1.formItem} />

                      {(client === "SELLER" ? transactionReportData?.sellerAgents : transactionReportData?.buyerAgents)?.map((agent, idx) => (
                        <Form.Item
                          label={<span className={styles1.padLeft10} style={{ fontSize: "15px" }}>{agent?.fullName}</span>}
                          key={idx}
                          className={`${styles1.formItem}`}
                        >
                          <div className={styles1.rowGroup}>
                            <Form.Item style={{ width: "30%" }} className={styles1.percentCol}>
                              <div className={styles1.input_with_symbol}>
                                <span className={styles1.symbol}>% </span>
                                <Form.Item name={`agentCommissionPercentage${idx + 1}`} noStyle>
                                  <NumberFormat
                                    className={`newNumberInput ${styles1.input}`}
                                    inputmode="numeric"
                                    displayType={"number"}
                                    allowNegative={false}
                                    isAllowed={getPercentageLimitChecker(`agentCommissionPercentage${idx + 1}`)}
                                    onBlur={handleBlurSave}
                                  />
                                </Form.Item>
                              </div>
                            </Form.Item>
                            <Form.Item style={{ width: "70%" }} className={styles1.amountCol}>
                              <div className={styles1.input_with_symbol}>
                                <span className={styles1.symbol}>$ </span>
                                <Form.Item name={`agentCommission${idx + 1}`} noStyle>
                                  <NumberFormat
                                    className={`newNumberInput ${styles1.input}`}
                                    inputmode="numeric"
                                    displayType={"number"}
                                    thousandSeparator={true}
                                    allowNegative={false}
                                    isAllowed={getAmountLimitChecker()}
                                    onBlur={handleBlurSave}
                                  />
                                </Form.Item>
                              </div>
                            </Form.Item>
                          </div>
                        </Form.Item>
                      ))}


                      {(addItems?.addedItems?.filter((el) => el?.name === "referral")?.length > 0 || checkListDataOnOffer?.commissionDistribution?.otherCommission?.referral || (checkListDataOnOffer?.referringAgentDetails &&
                        typeof checkListDataOnOffer?.referringAgentDetails === 'object' &&
                        Object.values(checkListDataOnOffer?.referringAgentDetails).some(
                          (val) => val !== undefined && val !== null && val !== ''
                        ))) && <Form.Item
                          label={<span style={{ fontSize: "17px" }}>Referral {checkListDataOnOffer?.referringAgentDetails?.fullName && <span> - Agent: {checkListDataOnOffer.referringAgentDetails.fullName}</span>}</span>}
                          className={styles1.formItem}
                        >
                          <div className={styles1.rowGroup}>
                            <Form.Item style={{ width: "30%" }} className={styles1.percentCol}>
                              <div className={styles1.input_with_symbol}>
                                <span className={styles1.symbol}>% </span>
                                <Form.Item name="referralPercentage" noStyle>
                                  <NumberFormat
                                    className={`newNumberInput ${styles1.input}`}
                                    inputmode="numeric"
                                    displayType={"number"}
                                    // suffix={"%"}
                                    allowNegative={false}
                                    isAllowed={getPercentageLimitChecker("referralPercentage")}
                                    onBlur={handleBlurSave}
                                  />
                                </Form.Item>
                              </div>
                            </Form.Item>
                            <Form.Item style={{ width: "70%" }} className={styles1.amountCol}>
                              <div className={styles1.input_with_symbol}>
                                <span className={styles1.symbol}>$ </span>
                                <Form.Item name="referral" noStyle>
                                  <NumberFormat
                                    className={`newNumberInput ${styles1.input}`}
                                    inputmode="numeric"
                                    displayType={"number"}
                                    thousandSeparator={true}
                                    allowNegative={false}
                                    isAllowed={getAmountLimitChecker()}
                                    onBlur={handleBlurSave}
                                  />
                                </Form.Item>
                              </div>
                            </Form.Item>
                          </div>
                        </Form.Item>}
                      {[
                        ...Object.entries(checkListDataOnOffer?.commissionDistribution?.otherCommission || {}).map(
                          ([key, value]) => ({
                            name: key,
                            label: key,
                            key,
                            custom: true,
                          })
                        ),
                        ...(addItems?.addedItems || [])
                      ]
                        .filter(
                          (field, index, self) =>
                            field?.custom &&
                            field?.name !== 'referral' &&
                            self.findIndex(f => f.name === field.name) === index
                        )
                        .map((field) => (
                          <Form.Item
                            key={field.key}
                            label={
                              <div style={{ fontSize: '17px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Dropdown overlay={<CommissionMenuItems ele={field} scrollTo={"commission"}/>} trigger={["click", "hover"]}>
                                  <MoreOutlined
                                    style={{ cursor: "pointer", fontSize: "23px", strokeWidth: "2", color: "#085190" }}
                                  />
                                </Dropdown>
                                {/* <DeleteOutlined
                                  style={{ color: '#2597FE', marginRight: 8, cursor: 'pointer' }}
                                  onClick={() => handleDeleteItem(field,"commisionDistribution")}
                                /> */}
                                <span>{field.label}</span>
                              </div>
                            }
                            className={styles1.formItem}
                          >
                            <div className={styles1.rowGroup}>
                              <Form.Item style={{ width: '30%' }} className={styles1.percentCol}>
                                <div className={styles1.input_with_symbol}>
                                  <span className={styles1.symbol}>% </span>
                                  <Form.Item name={`${field.name}Percentage`} noStyle>
                                    <NumberFormat
                                      className={`newNumberInput ${styles1.input}`}
                                      inputMode="numeric"
                                      displayType="input"
                                      // suffix="%"
                                      allowNegative={false}
                                      customInput={Input}
                                      isAllowed={getPercentageLimitChecker(`${field.name}Percentage`)}
                                      onBlur={handleBlurSave}
                                    />
                                  </Form.Item>
                                </div>
                              </Form.Item>
                              <Form.Item style={{ width: '70%' }} className={styles1.amountCol}>
                                <div className={styles1.input_with_symbol}>
                                  <span className={styles1.symbol}>$ </span>
                                  <Form.Item name={field.name} noStyle>
                                    <NumberFormat
                                      className={`newNumberInput ${styles1.input}`}
                                      inputMode="numeric"
                                      displayType="input"
                                      thousandSeparator={true}
                                      // prefix="$ "
                                      allowNegative={false}
                                      customInput={Input}
                                      isAllowed={getAmountLimitChecker()}
                                      onBlur={handleBlurSave}
                                    />
                                  </Form.Item>
                                </div>
                              </Form.Item>
                            </div>
                          </Form.Item>
                        ))}


                      <Button icon={<PlusCircleFilled />} style={{ borderRadius: "10px", marginTop: "10px" }} type="dashed" onClick={handleAddItemModal} className="no-print">
                        Add Distribution
                      </Button>

                      <Form.Item
                        label={<span style={{ fontSize: "17px" }}>Total Distribution</span>}
                        // name="totalCommission"
                        validateStatus={!isTotalValid && shortfallAmount ? "error" : ""}
                        help={!isTotalValid && shortfallAmount ? <span style={{ marginLeft: "20px" }}>Under allocated by ${formatPrice({ price: shortfallAmount })}</span> : isTotalValid ? <span style={{ marginLeft: "20px", color: "green" }}> All allocations match</span> : ""}
                        className={`${styles1.formItem} ${styles1.mrgtop}`}
                      >
                        <div className={styles1.input_with_symbol}>
                          <span className={styles1.symbol}>$ </span>
                          <Form.Item name="totalCommission" noStyle>
                            <NumberFormat
                              className={`newNumberInput ${isTotalValid ? styles1.greenInput : (gross > 0 && !isTotalValid) ? styles1.redInput : styles1.input}`}
                              inputmode="numeric"
                              displayType={"number"}
                              thousandSeparator={true}
                              allowNegative={false}
                              readOnly
                            />
                          </Form.Item>
                        </div>
                        </Form.Item>
                </Form>
              </div>


                {addItems?.addItemModalOpen && <ChecklistAddItem addItems={addItems} setAddItems={setAddItems} checkListDataOnOffer={checkListDataOnOffer} inputChangedRef={inputChangedRef}/>}
                </div>

              </> : !checklistDataLoading && <EmptyData />}
        </div>
      </Modal>
    </>
  )
}

export default ChecklistTable
